<template>
  <!-- <div style="position: relative; height:600px">
    <div v-if="loading" class="loading-div">
      <Button loading shape="circle" type="primary"></Button>
      <div>loading...</div>
    </div> -->
  <cTable
    ref="table"
    :fields="fields"
    :methods="methods"
    :config="config"
    :footer="footer"
  >
  </cTable>
  <!-- </div> -->
</template>

<script>
import {
  getIncome,
  addIncome,
  updateIncome,
  deleteIncome,
  getIncomeWeight,
} from "@/api/tracker/income";
import { getConfig } from "@/api/tracker/cost_page";
import { getExpense } from "@/api/finance/expense";
import cTable from "@/base/common/index";
import { Mul } from "@/libs/tools";
import numFun from "@/utils/numFun";
export default {
  components: {
    cTable,
  },
  props: {
    rows: {
      type: Object,
    },
		height:{
			type:Number,
			default:600
		}
  },
  data() {
    let that = this;
    return {
      loading: false,
      list: [],
      expenseList: [],
      currencyList: [],
      bubbleList: [],
      searchData: {},
      unitList: [],
      actual_weight: 0,
      volume_weight: 0,
      totalAmount: [],
      methods: {
        list: (p) => {
          p["extract_id"] = this.rows.id;
          p["type"] = this.rows.resType;
          return getIncome(p);
        },
        beforeHandleList: ({ data }) => {
          this.totalAmount = [];
          for (const key in data.count) {
            this.totalAmount.push({
              text: this.$t("total"),
              replace_currency: key,
              total_amount: data.count[key],
            });
          }
          data.rows.unshift({
            expense_item: "",
            currency: that.currencyList.length
              ? that.currencyList[0].value
              : "",
            bubble: "",
            quantity: 1,
            price: 0,
            cost: 0,
            amount: "",
            remarks: "",
            operator_name: "-",
            create_time: "-",
            price: 0,
          });
          return data.rows;
        },
        addIncome,
        updateIncome,
        deleteIncome,
        getIncomeWeight,
      },
      config: {
        height: this.height,
        slot: "div",
        resize: false,
        showOverflow: false,
        // showFooter: true,
        // footerCellClassName: "col-red",
        // footerMethod: ({ columns, data }) => {
        //   const sums = [];
        //   columns.forEach(column => {
        //     let sumCell = null;
        //     switch (column.property) {
        //       case "operator_name":
        //         sumCell = this.$t("summary") + this.$t("statistics");
        //         break;
        //       case "amount":
        //         sumCell = sumCell = numFun.sumNumFun(data, column.property, 2);
        //         break;
        //       default:
        //         sumCell = "-";
        //         break;
        //     }
        //     sums.push(sumCell);
        //   });
        //   // 返回一个二维数组的表尾合计
        //   return [sums];
        // }
      },
      footer: {
        show: () => false,
        render: (h) => {
          return h(
            "div",
            {
              class: "footer-content",
            },
            this.totalAmount.map((item) => {
              return h(
                "div",
                {
                  class: "footer-content-item",
                },
                [
                  h("span", { class: "span-head" }, item.text),
                  h(
                    "span",
                    { class: "span-head" },
                    item.replace_currency + ":"
                  ),
                  h(
                    "span",
                    {
                      class: "span-title",
                    },
                    numFun.formatNum(parseFloat(item.total_amount))
                  ),
                ]
              );
            })
          );
        },
      },
      fields: [
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          // component: "Input",
          placeholder() {
            return this.$t("operate");
          },
          disabled: true,
        },
        {
          name: () => this.$t("operate") + this.$t("time"),
          key: "create_time",
          // component: "Input",
          placeholder() {
            return this.$t("operate") + this.$t("time");
          },
          width: 100,
          disabled: true,
        },
        {
          name: () => this.$t("expense"),
          key: "expense_item",
          component: "Select",
          placeholder() {
            return this.$t("select") + this.$t("expense");
          },
          options: [],
          config: {
            label: "name",
            value: "id",
          },
        },
        {
          name: () => this.$t("calculation") + this.$t("currency_t"),
          key: "currency",
          component: "Select",
          placeholder() {
            return (
              this.$t("select") + this.$t("calculation") + this.$t("currency_t")
            );
          },
          options: [],
        },
        {
          name: () => this.$t("bubble_weight"),
          key: "bubble",
          component: "Select",
          placeholder() {
            return this.$t("select") + this.$t("bubble_weight");
          },
          options: [],
          // show: () => this.rows.resType != 1,
          // disabled: ({ row }) => {
          //   return row.bill_id > 0;
          // },
          methods: {
            async "on-change"({ value, row }) {
              if (value) {
                row["quantity"] = (
                  await getIncomeWeight({
                    extract_id: that.rows.id,
                    bubble: value,
                  })
                ).data.payload;
              } else {
                row["quantity"] = 0;
              }
            },
          },
        },
        {
          name: () => this.$t("noofpieces"),
          key: "quantity",
          component: "Input",
          bind: {
            type: "number",
          },
          placeholder() {
            return this.$t("enter") + this.$t("noofpieces");
          },
          methods: {
            "on-change"({ row }) {
              row.amount = Mul(row.quantity, row.price);
            },
          },
        },
        {
          name: () => this.$t("doublePrice"),
          key: "price",
          component: "Input",
          bind: {
            type: "number",
          },
          placeholder() {
            return this.$t("enter") + this.$t("doublePrice");
          },
          methods: {
            "on-change"({ row }) {
              row.amount = Mul(row.quantity, row.price);
            },
          },
        },
        {
          name: () => this.$t("gather") + this.$t("income"),
          key: "amount",
          component: "Input",
          placeholder() {
            return this.$t("gather") + this.$t("income");
          },
          disabled: true,
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          component: "Input",
          placeholder() {
            return this.$t("enter") + this.$t("Remarks");
          },
        },
        {
          type: "btns",
          width: 160,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name(obj) {
                return obj && obj.rowIndex == 0
                  ? this.$t("order_submit")
                  : this.$t("update");
              },
              type: "add",
              fnName: "add",
              bind: {
                type: (obj) =>
                  obj && obj.rowIndex == 0 ? "warning" : "success",
              },
              icon: (obj) =>
                obj && obj.rowIndex == 0 ? "md-add" : "ios-create-outline",
              id: [837, 838, 983, 982],
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              icon: "md-trash",
              show(obj) {
                return obj && obj.rowIndex != 0;
              },
              id: [839, 984],
            },
          ],
          methods: {
            add({ row }) {
              // console.log(this);
              let data = row;
              delete data.operator_name;
              data.type = that.rows.resType;
              data.extract_id = that.rows.id;
              this.handleRequestMethods(
                row.id ? "updateIncome" : "addIncome",
                data,
                true,
                true
              ).then((res) => {
                this.getList();
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "deleteIncome",
                    row.id,
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
  async mounted() {
    this.loading = true;
    let config = (await getConfig()).data.payload;
    this.currencyList = config.currency;
    this.expenseList = (await getExpense()).data.payload.rows;
    let bubbleList = config.bubble;
    // let bubbleList = (await getIncomeWeight()).data.payload;
    this.fields.forEach((el) => {
      if (el.key == "expense_item") el.options = this.expenseList;
      if (el.key == "currency") el.options = this.currencyList;
      if (el.key == "bubble") el.options = config.bubble;
    });
    if (this.$refs["table"]) {
      this.$refs["table"].list[0]["currency"] = this.currencyList.length
        ? this.currencyList[0].value
        : "";
      this.$refs["table"].list[0]["bubble"] = bubbleList.length
        ? bubbleList[0].value
        : "";
      this.$refs["table"].list[0]["quantity"] = (
        await getIncomeWeight({
          extract_id: this.rows.id,
          bubble: bubbleList[0].value,
        })
      ).data.payload;
    }
    this.loading = false;
  },
};
</script>
